import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-common-complete',
  templateUrl: './help-common-complete.component.html',
  styleUrls: ['./help-common-complete.component.scss']
})
export class HelpCommonCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
